import moment from "moment";
import { formats } from "../../config/constants";
import modelBaseV2 from "../model-base-v2.model";

/**
 * IMEI/SN Analysis - S/O Increase Status model
 * 
 * @author cmc.nttruong1
 */

const ImeiSnAnalysisSoIncreaseStatusModel = {
  search: (params) => {
    let queryString = modelBaseV2.toQueryString(params);
    return modelBaseV2.get(`/api/validationlog/imeiSnSoIncreaseStatusList?${queryString}`, {}, true)
  },
  exportFail: (params) => {
    return modelBaseV2.postDownload('/api/executesp/export/commonexcel', { body: params }, `IMEISN_LOG_FAIL_REPORT_${moment().format(formats.apiDateFormat)}`)
  },
  exportIncrease: (params) => {
    return modelBaseV2.postDownload('/api/executesp/export/commonexcel', { body: params }, `IMEISN_LOG_INCREASE_EXCEL_${moment().format(formats.apiDateFormat)}`)
  }
}

export default ImeiSnAnalysisSoIncreaseStatusModel;